import { ChartTextProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property';
import type { IAxisTitleProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/axis/axis-title.interface';
import type { IChartTitle } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import { getTextInParagraphList } from '../../text/utils/utils';
import { IAxisProperty } from './axis.interface';
import type { IParagraph } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-para.interface';
import i18n from '@i18next/i18n';

export class AxisTitleProperty extends ChartTextProperty<IChartTitle> implements IAxisTitleProperty {
    private parentProperty: IAxisProperty;

    public init(parentProperty: IAxisProperty) {
        this.parentProperty = parentProperty;
        return this;
    }

    public updateProps(props: Partial<IChartTitle>): void {
        this.parentProperty.updateProps({ title: props });
    }

    /**
     * 获取图表标题文本内容
     */
    public getTitleText(): string {
        const paragraphList = this.getParagraphList();
        return getTextInParagraphList(paragraphList);
    }

    /**
     * 更新坐标轴标题文本信息。
     * 目前策略是：之前多个段落多个textRun，最终会合成一个段落一个textRun
     * @param text
     */
    public updateTitleText(text: string) {
        if (text === '') {
            this.parentProperty.removeAxisTitle();
            return;
        }
        const paragraphList = this.getParagraphList();
        this.parentProperty.updateProps({
            title: {
                text: {
                    paragraphList: [
                        {
                            ...paragraphList[0],
                            textRuns: [
                                {
                                    ...paragraphList?.[0]?.textRuns?.[0],
                                    text,
                                },
                            ],
                        },
                    ],
                },
            },
        });
    }

    /**
     * 获取坐标轴标题段落信息。
     * 会优先取富文本信息，否则取文本默认信息
     */
    public getParagraphList(opts?): IParagraph[] {
        return super.getParagraphList(opts ?? {
            content: i18n.t('坐标轴标题'),
            level: 1,
            textAlign: 'center',
        });
    }
}
